import { defineComponent as _defineComponent } from 'vue'
import { nextTick, reactive, ref, watch } from 'vue';
import { useStore, useContext } from '@nuxtjs/composition-api';

import { useVuelidate } from '@vuelidate/core';
import {
  useForm,
  useCountries,
  useModalDialog,
  useValidationRules,
} from '~/composables';

interface FormData {
  name: string;
  phone: string;
  email: string;
  country: string;
  company: string;
  personalData: boolean;
}

interface Props {
  data?: Record<string, any>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryTryDemoForm',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: Record<string, any> };

const FORM_DEFAULTS = {
  name: '',
  phone: '',
  email: '',
  country: '',
  company: '',
  personalData: false,
};



const store = useStore();

const {
  formPending,
  confirm,
  submit,
  recaptcha: $recaptcha,
  isSubmitDisabled,
} = useForm();
const tryDemoModal = useModalDialog('try-demo-form');
const infoModal = useModalDialog('try-demo-form-info');
const { $gtm, nuxtState } = useContext();

const formData = reactive<FormData>({
  ...FORM_DEFAULTS,
});

const {
  required,
  checked,
  email,
  publicEmail,
  phone,
  alphaSpaces,
  errorMessage,
} = useValidationRules();

const v$ = useVuelidate(
  {
    name: { required, alphaSpaces },
    phone: { required, phone },
    email: { required, email, publicEmail },
    country: { required },
    company: { required },
    personalData: { checked },
  },
  formData,
);
const isFormStartEventSended = ref(false);

const { getCountriesList } = useCountries();
const countries = getCountriesList();
const openFile = () => {
  if (!props.data.file?.link) return;
  window.open(props.data.file.link, '_self');
};

const clearForm = () => {
  confirm.value = false;

  Object.assign(formData, {
    ...FORM_DEFAULTS,
  });

  nextTick(() => v$.value.$reset());
};

const submitForm = async () => {
  try {
    const formId = nuxtState.config.softwareTrialFormUuid;
    await submit({ ...createFormPayload(formData) }, formId);
    openFile();
    clearForm();
    tryDemoModal.close();
    infoModal.open();
  } catch (error) {
    console.error('Error submitting form', error);
  }
};

const pushFormStartEvent = () => {
  if (!isFormStartEventSended.value) {
    $gtm.push({
      event: 'form_start',
    });
  }
  isFormStartEventSended.value = true;
};

const createFormPayload = (formModel: FormData) => {
  return {
    lang: store.getters['config/getActiveLanguage'],
    website_url: store.getters['config/getConfig'].domain,
    lead_source: window.location.href,

    first_name: formModel.name,
    mobile_phone: formModel.phone,
    email: formModel.email,
    country: formModel.country,
    company_name: formModel.company,
  };
};

watch(formData, () => {
  pushFormStartEvent();
});
watch(confirm, () => {
  pushFormStartEvent();
});

return { __sfc: true,FORM_DEFAULTS, props, store, formPending, confirm, submit, $recaptcha, isSubmitDisabled, tryDemoModal, infoModal, $gtm, nuxtState, formData, required, checked, email, publicEmail, phone, alphaSpaces, errorMessage, v$, isFormStartEventSended, getCountriesList, countries, openFile, clearForm, submitForm, pushFormStartEvent, createFormPayload }
}

})